"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSpectralToRMSSum = addSpectralToRMSSum;
exports.calculateAlphaForCFBVoltageNoise = calculateAlphaForCFBVoltageNoise;
exports.calculateArraysForNoiseGainPlot = calculateArraysForNoiseGainPlot;
exports.calculateClosedLoopGain = calculateClosedLoopGain;
exports.calculateComplexA = calculateComplexA;
exports.calculateComplexA_PolesAndZeroes = calculateComplexA_PolesAndZeroes;
exports.calculateComplexAlpha_Stage2 = calculateComplexAlpha_Stage2;
exports.calculateComplexAlpha_TIA = calculateComplexAlpha_TIA;
exports.calculateComplexBeta_Stage2 = calculateComplexBeta_Stage2;
exports.calculateComplexBeta_TIA = calculateComplexBeta_TIA;
exports.calculateComplexClosedLoopGain = calculateComplexClosedLoopGain;
exports.calculateENOB = calculateENOB;
exports.calculateMaxSupplyVoltage = calculateMaxSupplyVoltage;
exports.calculateMinSupplyVoltage = calculateMinSupplyVoltage;
exports.calculateNaturalFrequencyAndQ = calculateNaturalFrequencyAndQ;
exports.calculateNoise = calculateNoise;
exports.calculateOpAmpCurrentNoiseGain_Stage2 = calculateOpAmpCurrentNoiseGain_Stage2;
exports.calculateOpAmpCurrentNoiseGain_TIA = calculateOpAmpCurrentNoiseGain_TIA;
exports.calculateOpAmpVoltageNoiseGain = calculateOpAmpVoltageNoiseGain;
exports.calculateRfNoiseGain_Stage2 = calculateRfNoiseGain_Stage2;
exports.calculateRfNoiseGain_TIA = calculateRfNoiseGain_TIA;
exports.calculateRfilterNoiseGain = calculateRfilterNoiseGain;
exports.calculateRgNoiseGain_Stage2 = calculateRgNoiseGain_Stage2;
exports.calculateRinNoiseGain = calculateRinNoiseGain;
exports.calculateSNR = calculateSNR;
exports.calculateSpectralDensityForOneFrequency = calculateSpectralDensityForOneFrequency;
exports.createMagnitudeArray = createMagnitudeArray;
exports.getActualFpFq = getActualFpFq;
exports.getRoughBW = getRoughBW;
exports.getSpectralNoiseData = getSpectralNoiseData;
exports.solveQ_fnAndMagnitude = solveQ_fnAndMagnitude;
var _complex = _interopRequireDefault(require("./complex"));
var AdiMath = _interopRequireWildcard(require("./math"));
var Common = _interopRequireWildcard(require("./common"));
var Solver = _interopRequireWildcard(require("./solver"));
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//Get a rough BW that doesn't change with peaking.   We'll use this so that our cutoff frequency stays
//in the middle of our plots
function getRoughBW(stagesObject) {
  var opAmp = stagesObject.stage1.opAmp;
  let gbw;
  if (opAmp.feedbackMethod === 'Current') {
    gbw = opAmp.cfb.zbw / opAmp.cfb.rIn;
  } else {
    gbw = opAmp.gbw;
  }
  var polefrequency = 1 / (2 * Math.PI * stagesObject.stage1.cin * stagesObject.stage1.rf);
  return Math.sqrt(polefrequency * gbw);
}

// export function createComplexClosedLoopGainArray(frequencyArray, stages, inputValues) {
//     var i, complexA, complexAlpha, complexBeta, complexClosedLoopGain, complexClosedLoopGain_2ndStage;
//     var complexClosedLoopGainArray = [];
//     var stage1 = stages.stage1, stage2 = stages.stage2;
//     var freqLength = frequencyArray.length;

//     for (i = 0; i < freqLength; i++) {
//         complexA = this.calculateComplexA(frequencyArray[i], stage1);
//         complexAlpha = this.calculateComplexAlpha_TIA(frequencyArray[i], stage1);
//         complexBeta = this.calculateComplexBeta_TIA(frequencyArray[i], stage1);
//         complexClosedLoopGain = this.calculateComplexClosedLoopGain(complexA, complexBeta, complexAlpha);

//         if (inputValues.stages === PhotodiodeConstants.pdStages.twoStage) {
//             complexA = this.calculateComplexA(frequencyArray[i], stage2);
//             complexAlpha = this.calculateComplexAlpha_Stage2(frequencyArray[i], stage2);
//             complexBeta = this.calculateComplexBeta_Stage2(frequencyArray[i], stage2);
//             complexClosedLoopGain_2ndStage = this.calculateComplexClosedLoopGain(complexA, complexBeta, complexAlpha);
//             complexClosedLoopGain = complexClosedLoopGain.mult(complexClosedLoopGain_2ndStage);
//         }

//         complexClosedLoopGainArray.push(magnitude);
//     }

//     return complexClosedLoopGainArray;
// }

//more accurate than original magnitude calculation function
function createMagnitudeArray(frequencyArray, stages, inputValues) {
  var i, complexA, complexAlpha, complexBeta, magnitude, magnitude_2ndStage;
  var magnitudeArray = [];
  var stage1 = stages.stage1,
    stage2 = stages.stage2;
  var freqLength = frequencyArray.length;
  var complexAPhases = [];
  for (i = 0; i < freqLength; i++) {
    complexA = this.calculateComplexA(frequencyArray[i], stage1);
    complexAPhases.push(Math.atan2(complexA.imaginary, complexA.real) * 180 / Math.PI);
    complexAlpha = this.calculateComplexAlpha_TIA(frequencyArray[i], stage1);
    complexBeta = this.calculateComplexBeta_TIA(frequencyArray[i], stage1);
    magnitude = this.calculateClosedLoopGain(complexA, complexBeta, complexAlpha);
    if (inputValues.stages === _photodiodeConstants.default.pdStages.twoStage) {
      complexA = this.calculateComplexA(frequencyArray[i], stage2);
      complexAlpha = this.calculateComplexAlpha_Stage2(frequencyArray[i], stage2);
      complexBeta = this.calculateComplexBeta_Stage2(frequencyArray[i], stage2);
      magnitude_2ndStage = this.calculateClosedLoopGain(complexA, complexBeta, complexAlpha);
      magnitude *= magnitude_2ndStage;
    }
    magnitudeArray.push(magnitude);
  }
  return magnitudeArray;
}

//This function calculations the natural frequency and Q for display on the Frequency Response graph
function calculateNaturalFrequencyAndQ(stages, numStages) {
  var stage1 = stages.stage1;
  var rin = stage1.rin;
  var rf = stage1.rf;
  let gbw;
  if (stage1.opAmp.feedbackMethod === 'Current' && stage1.opAmp.cfb) {
    gbw = stage1.opAmp.cfb.zbw / stage1.opAmp.cfb.rIn;
  } else {
    gbw = stage1.opAmp.gbw;
  }
  var cin = stage1.cin;
  var cf = stage1.cf;
  var fn = Solver.solveBW(cin, rin, cf, rf, gbw);
  var fnAndQ = this.solveQ_fnAndMagnitude(fn, stages, numStages);
  return fnAndQ;
}

//This function solves for Q using the magnitude value at the natural frequency.
//In other words, if we just had the graph, what would Q be?
//We use this method to show the "real Q".  Unlike our Q calculation from circuit values, which just assumes
//a 2nd order circuit, this method incorporates the additional poles.
function solveQ_fnAndMagnitude(fn, stages, numStages) {
  //we'll just reuse createMagnitudeArray function, so set up data in the way it likes
  var frequencyArray = [1e-9, fn];
  var inputValues = {
    stages: numStages
  };
  var magnitudeArray = this.createMagnitudeArray(frequencyArray, stages, inputValues);
  var Q = magnitudeArray[1] / magnitudeArray[0];
  var results = this.getActualFpFq(fn, Q, stages, inputValues);
  return {
    fn: results[0],
    q: results[1]
  };
}

//This function calculates the 3dB frequency only use the plot information
//It assumes that the first point in the plot is equivalent to the DC gain, and calculates 0.707 drop off from it.
// export function calculate3dBFromPlot(magnitudeArray, frequencyArray) {
//     var dcValue = magnitudeArray[0];
//     var threedBFound = false;
//     var threedB = Math.sqrt(2) / 2 * dcValue;

//     for (var i = 1; i < magnitudeArray.length; i++) {
//         if (magnitudeArray[i] < threedB) {
//             threedBFound = true;
//             var frequencyInterval = frequencyArray[i] / frequencyArray[i - 1];
//             var voltageInterval = magnitudeArray[i] / magnitudeArray[i - 1];
//             var voltageIntervalTo3dB = threedB / magnitudeArray[i - 1];
//             var fraction = (1 - voltageIntervalTo3dB) / (1 - voltageInterval);
//             var frequencyIntervalTo3dB = fraction * (frequencyInterval - 1) + 1;
//             var interpolated3dBFrequency = frequencyIntervalTo3dB * frequencyArray[i - 1];
//             break;
//         }
//     }

//     if (threedBFound)
//         return interpolated3dBFrequency;
//     else
//         return NaN;
// }

//This function calculates the arrays for the noise gain plot
//Inputs:
//frequencyArray:  array of frequency points
//stage:  stagesObject.stage1
function calculateArraysForNoiseGainPlot(frequencyArray, stage) {
  var i,
    capGainArray = [],
    noiseGainArray = [],
    opAmpArray = [],
    rcParArray = [];
  var capGain = (stage.cin + stage.cf) / stage.cf;
  let rPar;
  if (stage.opAmp.feedbackMethod === 'Current') {
    rPar = stage.rf;
  } else {
    rPar = stage.rf * stage.rin / (stage.rf + stage.rin);
  }
  var rcParallelPole = 1 / (2 * Math.PI * rPar * (stage.cin + stage.cf));
  for (i = 0; i < frequencyArray.length; i++) {
    var complexA = this.calculateComplexA(frequencyArray[i], stage);
    // if (i == 103) {
    //     var placetoStop = 1;
    // }

    var complexBeta = this.calculateComplexBeta_TIA(frequencyArray[i], stage);
    let noiseGain, opAmpGain;
    if (stage.opAmp.feedbackMethod === 'Current') {
      var complexAlpha = this.calculateAlphaForCFBVoltageNoise(stage, frequencyArray[i]);
      noiseGain = this.calculateOpAmpVoltageNoiseGain(complexA, complexBeta, complexAlpha);
      opAmpGain = complexA.magnitude() / stage.rin;
    } else {
      noiseGain = this.calculateOpAmpVoltageNoiseGain(complexA, complexBeta);
      opAmpGain = complexA.magnitude();
    }
    var rcParRatio = frequencyArray[i] / rcParallelPole;
    var rcParGain = Math.sqrt(rcParRatio * rcParRatio + 1);
    capGainArray.push(capGain);
    noiseGainArray.push(noiseGain);
    opAmpArray.push(opAmpGain);
    rcParArray.push(rcParGain);
  }
  return [noiseGainArray,
  //Dark black line, in legend call this "Noise Gain"
  capGainArray,
  //Red dotted line, in legend call this "(Cin + Cf)/Cf "
  opAmpArray,
  //Green dotted line, in legend call this "Op Amp Gain"
  rcParArray //Blue dotted line, in legend call this "(Cin||Cf)(Rin||Rf) Zero"
  ];
}

//This function calculates the arrays for the stability plot
//Inputs:
//frequencyArray:  array of frequency points
//stage:  stagesObject.stage1
// export function calculateArraysForStabilityPlot(frequencyArray, stage) {
//     let gbw;
//     if (stage.opAmp.feedbackMethod === "Current") {
//         gbw = parseFloat(stage.opAmp.zbw) / parseFloat(stage.opAmp.rIn);
//     }
//     else {
//         gbw = stage.opAmp.gbw;
//     }
//     var rPar = stage.rf * stage.rin / (stage.rf + stage.rin);
//     var rcParallelPole = 1 / (2 * Math.PI * rPar * (stage.cin + stage.cf));
//     var rfcfZero = 1 / (2 * Math.PI * stage.rf * stage.cf);
//     var resDividerGain = stage.rin / (stage.rf + stage.rin);
//     var capDividerGain = stage.cf / (stage.cin + stage.cf);
//     var A, beta, loopGain, frequency, i;
//     var AArray = [], betaArray = [], loopGainArray = [];

//     for (i = 0; i < frequencyArray.length; i++) {
//         frequency = frequencyArray[i];

//         //A
//         if (frequency < (gbw * 2))
//             A = gbw / frequency;
//         else
//             A = (gbw / frequency) * ((gbw * 2) / frequency);

//         //Beta
//         if (resDividerGain > capDividerGain) { //typical voltage feedback case, since resGain is not much smaller than 1.
//             if (frequency < rcParallelPole)
//                 beta = resDividerGain;
//             else if (frequency < rfcfZero)
//                 beta = resDividerGain * rcParallelPole / frequency;
//             else
//                 beta = capDividerGain;
//         }
//         else {  //can happen with current feedback case, since low rin of current feedback can create large resGain
//             if (frequency < rfcfZero)
//                 beta = resDividerGain;
//             else if (frequency < rcParallelPole)
//                 beta = resDividerGain * frequency / rfcfZero;
//             else
//                 beta = capDividerGain;
//         }

//         //Loop Gain
//         loopGain = A * beta;

//         //Now push to arrays
//         AArray.push(A);
//         betaArray.push(beta);
//         loopGainArray.push(loopGain);
//     }

//     return [loopGainArray,      //Dark black line, in legend call this "Loop Gain (A * beta)"
//         betaArray,               //Red dotted line, in legend call this "Feedback (beta)"
//         AArray                   //Green dotted line, in legend call this "Op Amp Gain (A)"
//     ];                           //We will only have three lines - there is no blue dotted line.
// }

//This function is used for displaying the minimum supply voltage on the next steps page
function calculateMinSupplyVoltage(userInputs, stage1, stage2) {
  var outHeadroom1, outHeadroom2, inHeadroom2, minSupplyOut2, minSupplyIn2, minSupplyOut1, minSupply, secondStageGain;
  var peakVoltage = userInputs.peakVoltage;
  if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
    secondStageGain = 1 + stage2.rf / stage2.rg;
    outHeadroom2 = stage2.opAmp.outHeadroomPlus;
    minSupplyOut2 = outHeadroom2 + peakVoltage;
    if (userInputs.biasPreference === 'negative') {
      //output of first stage is positive so check its positive headroom
      outHeadroom1 = stage1.opAmp.outHeadroomPlus;
      minSupplyOut1 = outHeadroom1 + peakVoltage / secondStageGain;

      //since using noninverting stage, need input headroom of 2nd stage
      inHeadroom2 = stage2.opAmp.inHeadroomPlus;
      minSupplyIn2 = inHeadroom2 + peakVoltage / secondStageGain;
    } else {
      //output of first stage is negative so check its negative headroom
      outHeadroom1 = stage1.opAmp.outHeadroomMinus;
      minSupplyOut1 = outHeadroom1 + peakVoltage / secondStageGain;

      //common mode of inverting stages always stays at 0, so don't have to worry about input range
      minSupplyIn2 = 0;
    }
    minSupply = Math.max(minSupplyOut1, minSupplyIn2, minSupplyOut2, stage1.opAmp.minSupplyVoltage / 2, stage2.opAmp.minSupplyVoltage / 2);
  }
  if (userInputs.stages === _photodiodeConstants.default.pdStages.oneStage) {
    if (userInputs.biasPreference === 'negative') {
      outHeadroom1 = stage1.opAmp.outHeadroomPlus;
    } else {
      outHeadroom1 = stage1.opAmp.outHeadroomMinus;
    }
    minSupplyOut1 = outHeadroom1 + peakVoltage;
    minSupply = Math.max(minSupplyOut1, stage1.opAmp.minSupplyVoltage / 2);
  }
  return minSupply;
}
function calculateMaxSupplyVoltage(userInputs, stage1, stage2) {
  var maxSupply;
  if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
    maxSupply = Math.min(stage1.opAmp.maxSupplyVoltage / 2, stage2.opAmp.maxSupplyVoltage / 2);
  } else {
    maxSupply = stage1.opAmp.maxSupplyVoltage / 2;
  }
  return maxSupply;
}
function getSpectralNoiseData(frequencies, stages) {
  var noiseInfo = this.calculateNoise(frequencies, stages);
  return noiseInfo.graphLines;
}

// PRIVATE FUNCTIONS
//When calculating the voltage noise of a current feedback amp, we have to convert the voltage into a current.
//Therefore the alpha is not 1, like in the voltage feedback case.  The alphadepends on both the
//input resistance of the op amp as well as the feedback components.  This function calculates it.
function calculateAlphaForCFBVoltageNoise(stage, frequency) {
  var rf_c_s = stage.rf * (stage.cin + stage.cf) * 2 * Math.PI * frequency;
  var complexNum = _complex.default.createComplex(1, rf_c_s);
  var complexDenom = _complex.default.createComplex(stage.rin + stage.rf, stage.rin * rf_c_s);
  var complexAlpha = complexNum.divideDestroy(complexDenom);
  return complexAlpha;
}

// Calculate feedforward factor for TIA
function calculateComplexAlpha_TIA(frequency, stage) {
  var rParallel = stage.rf * stage.rin / (stage.rf + stage.rin);
  var cParallel = stage.cin + stage.cf;
  var pole = 1 / (2 * Math.PI * cParallel * rParallel);

  //Calculate numerator.   Note that we assume current source pulls out of circuit, which would normally need a negative sign.
  //However since we are connected to the inverting input, the negatives cancel out, so no negative sign needed.
  let complexDCgain;
  if (stage.opAmp.feedbackMethod === 'Current') {
    complexDCgain = _complex.default.createComplex(rParallel / stage.rin, 0);
  } else {
    complexDCgain = _complex.default.createComplex(rParallel, 0);
  }
  var complexDenom = _complex.default.createComplex(1, frequency / pole);
  return complexDCgain.divideDestroy(complexDenom);
}

// Calculate feedforward factor for TIA
function calculateComplexAlpha_Stage2(frequency, stage) {
  var complexNum, complexDenom;

  //Current feedback
  if (stage.opAmp.feedbackMethod === 'Current' && stage.opAmp.cfb) {
    if (stage.rfilter === undefined) {
      //current feedback not allowed in inverting configuration - should have been caught before this point.
      console.log('Error:  current feedback part in stage 2 inverting configuration');
      return _complex.default.createComplex(1e60, 0);
    } else {
      //non-inverting case
      var OpAmpRin = stage.opAmp.cfb.rIn;
      var rPar = stage.rf * stage.rg / (stage.rf + stage.rg);
      var currentThroughRin = 1 / (OpAmpRin + rPar);
      return _complex.default.createComplex(currentThroughRin, 0);
    }
  }

  //Voltage feedback
  else {
    //If no rfilter, then using inverting configuration
    if (stage.rfilter === undefined || stage.rfilter === null) {
      /*parallel(rg,C) / (parallel(rg,C) + rf) = rg/(rg +rf*rg*C*s + rf)*/
      complexNum = _complex.default.createComplex(-1 * stage.rf, 0); //Multiply by -1 here to signify a negative alpha, since we're feeding into inverting input
      complexDenom = _complex.default.createComplex(stage.rg + stage.rf, stage.rg * stage.rf * stage.cfilter * 2 * Math.PI * frequency);
    }
    //noninverting configuration.   This is a calculation for the low pass filter before the noninverting amp (since noninverting amp by itself has alpha = 1)
    else {
      complexNum = _complex.default.createComplex(1, 0);
      complexDenom = _complex.default.createComplex(1, stage.rfilter * stage.cfilter * 2 * Math.PI * frequency);
    }
    return complexNum.divideDestroy(complexDenom);
  }
}

//Calculates feedback factor for TIA
function calculateComplexBeta_TIA(frequency, stage) {
  var rParallel = stage.rf * stage.rin / (stage.rf + stage.rin);
  var cParallel = stage.cin + stage.cf;
  var pole = 1 / (2 * Math.PI * cParallel * rParallel);
  var zero = 1 / (2 * Math.PI * stage.rf * stage.cf);
  let ACgain;
  if (stage.opAmp.feedbackMethod === 'Current') {
    ACgain = stage.cf / (cParallel * stage.rin);
  } else {
    ACgain = stage.cf / cParallel;
  }
  var complexNum = _complex.default.createComplex(ACgain * zero, ACgain * frequency);
  var complexDenom = _complex.default.createComplex(pole, frequency);
  return complexNum.divideDestroy(complexDenom);
}

// Calculate feedback factor for the second stage
function calculateComplexBeta_Stage2(frequency, stage) {
  var complexNum, complexDenom;
  //Current feedback
  if (stage.opAmp.feedbackMethod === 'Current' && stage.opAmp.cfb) {
    if (stage.rfilter === undefined) {
      //current feedback not allowed in inverting configuration - should have been caught before this point.
      console.log('Error:  current feedback part in stage 2 inverting configuration');
      return _complex.default.createComplex(1e60, 0);
    } else {
      //non-inverting case
      var OpAmpRin = stage.opAmp.cfb.rIn;
      var rPar = stage.rg * OpAmpRin / (stage.rg + OpAmpRin);
      var voltageAtInvertingTerminal = rPar / (rPar + stage.rf);
      var currentThroughRin = voltageAtInvertingTerminal / OpAmpRin;
      return _complex.default.createComplex(currentThroughRin, 0);
    }
  }

  //Voltage feedback
  else {
    //If no rfilter, then using inverting configuration which has capacitor in feedback
    if (stage.rfilter === undefined) {
      /*   rf / (parallel(rg,C) + rf) = (rf +rf*rg*C*s) / (rg +rf*rg*C*s + rf)  */
      complexNum = _complex.default.createComplex(stage.rg, stage.rf * stage.rg * stage.cfilter * 2 * Math.PI * frequency);
      complexDenom = _complex.default.createComplex(stage.rg + stage.rf, stage.rg * stage.rf * stage.cfilter * 2 * Math.PI * frequency);
      return complexNum.divideDestroy(complexDenom);
    }
    //noninverting configuration
    else {
      return _complex.default.createComplex(stage.rg / (stage.rg + stage.rf), 0);
    }
  }
}

//Calculates the open loop gain of the op amp
//We assume a modified integrator model for op amp: infinite Aol, but assume a secondary pole 2x past gbw
//This corresponds to the following formula:  (2*PI*gbw/s) * 1/( s/(4*PI*gbw) + 1)
//We do the math slightly differently below so we can do less complex math (which is expensive)
function calculateComplexA(frequency, stage) {
  var pi = Math.PI;
  var sImaginary = frequency * 2 * pi;
  var sSquared = -4 * pi * pi * frequency * frequency;
  var complexA;
  let gbw;
  let complexTopTerm;
  let complexBottomTerm;
  if (stage.opAmp.feedbackMethod === 'Current' && stage.opAmp.cfb) {
    //model CFB amp as having a Z curve that is ideal integrator + 2 identical poles at higher frequency
    //the two poles are set so there is 135 degrees of phase at the minRf.   This occurs when the poles are 2.414214 * minRf frequency
    //equations is zbw / (s * (s/freqDualPole + 1)^2)
    gbw = stage.opAmp.cfb.zbw / stage.opAmp.cfb.rIn;
    var freq135 = stage.opAmp.cfb.zbw / stage.opAmp.cfb.minRf;
    // var rad135 = freq135 * 2 * pi;
    var freqDualPole = freq135 * 2.414214;
    var radDualPole = freqDualPole * 2 * pi;
    var ZBWrad = stage.opAmp.cfb.zbw * 2 * pi;
    var sCubed = -8 * pi * pi * pi * frequency * frequency * frequency;
    complexTopTerm = _complex.default.createComplex(radDualPole * radDualPole * ZBWrad, 0);
    complexBottomTerm = _complex.default.createComplex(2 * sSquared * radDualPole, sCubed + radDualPole * radDualPole * sImaginary);
    complexA = complexTopTerm.divideDestroy(complexBottomTerm);
  }
  //Voltage feedback case
  else {
    gbw = stage.opAmp.gbw;
    var GBWrad = gbw * 2 * pi;
    let rOutDivider;
    //Math to simulate effect of op amp Rout.  Important when cf and cin capacitors are large.
    if (stage.opAmp.rOut !== undefined && stage.opAmp.rOut !== null && !isNaN(stage.opAmp.rOut) && stage.cin !== undefined) {
      var rOut = stage.opAmp.rOut;
      var topTermRout = _complex.default.createComplex(1, (stage.rf * stage.cin + stage.rf * stage.cf) * sImaginary);
      var bottomTermRout = _complex.default.createComplex(1 + sSquared * rOut * stage.cin * stage.rf * stage.cf, (stage.rf * stage.cin + stage.rf * stage.cf + rOut * stage.cin) * sImaginary);
      rOutDivider = topTermRout.divideDestroy(bottomTermRout);
    } else {
      rOutDivider = _complex.default.createComplex(1, 0);
    }

    //Some voltage feedback parts not stable at G=1.  Here is where we handle this
    if (stage.opAmp.polesZeroes) {
      complexA = this.calculateComplexA_PolesAndZeroes(stage.opAmp.polesZeroes, sImaginary);
    } else {
      //sets 2nd pole at gbw * 2
      complexTopTerm = _complex.default.createComplex(2 * GBWrad * GBWrad, 0).multDestroy(rOutDivider);
      complexBottomTerm = _complex.default.createComplex(sSquared, 2 * GBWrad * sImaginary);
      complexA = complexTopTerm.divideDestroy(complexBottomTerm);
    }
  }
  return complexA;
}

//This function is for used for calculating op amps with poles and zeros.
//This function allows us to set poles, left hand plan zeros, and one right half plane zero independently of gbw
//This function does not use a dominant pole.  Instead the gbw sets the position of the open loop gain line at lower frequencies
//(i.e. compute gbw as if the 20 dB/decade line keeps going through the 0 dB line)
//The equation we start with is:
// GBW/s * p0/(s+p0) * p1/(s+p1) * p2/(s+p2) * p3/(s+p3) * p4/(s+p4) * (s+z0)/z0 * (s+z1)/z1 * (s-rhpz)/rhpz
// Because everything is a ratio we can dispense with converting everything with 2*PI
function calculateComplexA_PolesAndZeroes(polesZeroes, sImaginary) {
  var i;
  var freq = sImaginary / (2 * Math.PI);

  //Try to keep our complex number declarations to just these three, since each new complex number is quite expensive
  var complexProduct = _complex.default.createComplex(0, 0);
  var complexDenom = _complex.default.createComplex(0, 0);
  var complexNum = _complex.default.createComplex(0, 0);

  //GBW/s
  complexProduct.real = 0;
  complexProduct.imaginary = -1 * polesZeroes.gbw / freq;

  //poles:  p[i]/(s+p[i])
  for (i = 0; i < polesZeroes.p.length; i++) {
    complexNum.real = polesZeroes.p[i];
    complexNum.imaginary = 0;
    complexDenom.real = polesZeroes.p[i];
    complexDenom.imaginary = freq;
    complexProduct = complexNum.divideDestroy(complexDenom).multDestroy(complexProduct);
  }

  //zeros:  (s+z[i])/z[i]
  for (i = 0; i < polesZeroes.z.length; i++) {
    complexNum.real = polesZeroes.z[i];
    complexNum.imaginary = freq;
    complexDenom.real = polesZeroes.z[i];
    complexDenom.imaginary = 0;
    complexProduct = complexNum.divideDestroy(complexDenom).multDestroy(complexProduct);
  }

  //right half plane zero:  (s-rhpz)/rhpz
  if (polesZeroes.rhpz) {
    complexNum.real = -1 * polesZeroes.rhpz;
    complexNum.imaginary = freq;
    complexDenom.real = -1 * polesZeroes.rhpz;
    complexDenom.imaginary = 0;
    complexProduct = complexNum.divideDestroy(complexDenom).multDestroy(complexProduct);
  }
  return complexProduct;
}
function calculateNoise(frequencyArray, stageInfo) {
  var i, j;
  var totalArray = [];
  var stage1 = stageInfo.stage1;
  var stage2 = stageInfo.stage2;
  var results;
  var stage1Keys = ['total', 'rf', 'rin', 'opAmpI', 'opAmpV'];
  var stage2Keys = ['total', 'rf', 'rg', 'rfilter', 'opAmpI', 'opAmpV'];
  var stage1Sums = {
    total: 0,
    rf: 0,
    rin: 0,
    opAmpI: 0,
    opAmpV: 0
  };
  var stage2Sums = {
    total: 0,
    rf: 0,
    rg: 0,
    rfilter: 0,
    opAmpI: 0,
    opAmpV: 0
  };
  var key = '';
  var individualStage1Spectrals = {
    total: [],
    rf: [],
    rin: [],
    opAmpI: [],
    opAmpV: []
  };
  var individualStage2Spectrals = {
    total: [],
    rf: [],
    rg: [],
    rfilter: [],
    opAmpI: [],
    opAmpV: []
  };

  //console.log(stage2);
  for (i = 0; i < frequencyArray.length; i++) {
    results = this.calculateSpectralDensityForOneFrequency(frequencyArray[i], stage1, stage2);

    //arrays for graphing.  Plot all the data as agreed for ARNA-5363
    for (j = 0; j < stage1Keys.length; j++) {
      key = stage1Keys[j];
      individualStage1Spectrals[key].push([frequencyArray[i], results.stage1[key]]);
    }
    if (results.stage2.total > 0) {
      for (j = 0; j < stage2Keys.length; j++) {
        key = stage2Keys[j];
        individualStage2Spectrals[key].push([frequencyArray[i], results.stage2[key]]);
      }
    }
    totalArray.push([frequencyArray[i], results.total]);
  }

  //RMS noise calculations
  let halfOfTheFrequencies = getColumnFrom2DArray(totalArray, 0);
  let totalRMSNoise = computeRMSNoiseFromSpectralArray(halfOfTheFrequencies, getColumnFrom2DArray(totalArray, 1));
  for (j = 0; j < stage1Keys.length; j++) {
    key = stage1Keys[j];
    stage1Sums[key] = computeRMSNoiseFromSpectralArray(halfOfTheFrequencies, getColumnFrom2DArray(individualStage1Spectrals[key], 1));
  }
  if (results.stage2.total > 0) {
    for (j = 0; j < stage2Keys.length; j++) {
      key = stage2Keys[j];
      stage2Sums[key] = computeRMSNoiseFromSpectralArray(halfOfTheFrequencies, getColumnFrom2DArray(individualStage2Spectrals[key], 1));
    }
  }
  var graphLines = [totalArray, individualStage1Spectrals.opAmpV, individualStage1Spectrals.opAmpI, individualStage1Spectrals.rf, individualStage1Spectrals.rin, individualStage2Spectrals.opAmpV, individualStage2Spectrals.opAmpI, individualStage2Spectrals.rf, individualStage2Spectrals.rg, individualStage2Spectrals.rfilter];
  return {
    total: totalRMSNoise,
    stage1: stage1Sums,
    stage2: stage2Sums,
    graphLines: graphLines
  };
}
function getColumnFrom2DArray(array2D, columnIndex) {
  return array2D.map(row => row[columnIndex]);
}
function calculateSNR(rmsNoise, peakToPeakV) {
  'use strict';

  var peakRMS = peakToPeakV / (2 * Math.sqrt(2));
  var SNR_VperV = peakRMS / rmsNoise;
  var SNR_dB = 20 * AdiMath.logBaseTen(SNR_VperV);
  return SNR_dB;
}

//This function does the well known:
//ENOB = (SINAD - 1.76) / 6.02
//But assume 0 distoration and use SNR instead of SINAD
//Since we have a computer we also compute the long form of 1.76 and 6.02.  Since it's a cheap calculation, might as well be accurate.
function calculateENOB(SNR) {
  'use strict';

  var onePtSevenSix = 10 * AdiMath.logBaseTen(3 / 2); //1.76
  var sixPtZeroTwo = 20 * AdiMath.logBaseTen(2); //6.02
  var ENOB = (SNR - onePtSevenSix) / sixPtZeroTwo;
  return ENOB;
}

//Computes a single RMS number from an array of spectral noise points
//Spectral noise points do not need to be evenly spaced
//Algorithm: For maximum accuracy we determine the midpoints between frequencies in the array.  For each point in the array we then compute the rms noise from the
//midpoint below to the midpoint above.  This is probably overkill.  If we find this is too many calculations, it's probably find to just do
//away with the midpoint calculations and just compute in the span from one point from the next.  We'd be a little less accurate (because all the multiplication is on one side
//of a point rather than having it in the middle.)  But probably not a big enough error to matter.
//frequencyArray:  array of frequencies in Hz, each point in frequency array is the frequency of the corresponding point in spectralNoiseArray
//spectralNoiseArray: array of spectral noises in V/rt(Hz)
//Returns rmsNoise, a single number in Vrms

//Potential unit test:
// testFrequencies = [1, 2, 5, 10, 20, 50, 100];
// testSpectrals =   [1, 1, 1,  1,  1,  1,   1];
// Expected result: 9.9498743710662

function computeRMSNoiseFromSpectralArray(frequencyArray, spectralNoiseArray) {
  //Will start measuring exactly at frequencyArray[0], so only look at energy from frequency[0] to midPointAbove
  let midPointBelow = frequencyArray[0];
  let rmsNoise = 0;
  let midPointAbove, rmsNoiseSinglePoint;
  for (let i = 0; i < frequencyArray.length - 1; i++) {
    midPointAbove = Math.sqrt(frequencyArray[i] * frequencyArray[i + 1]);
    rmsNoiseSinglePoint = spectralNoiseArray[i] * Math.sqrt(midPointAbove - midPointBelow);
    rmsNoise = Math.sqrt(rmsNoise * rmsNoise + rmsNoiseSinglePoint * rmsNoiseSinglePoint);
    midPointBelow = midPointAbove;
  }

  //Last point
  //We want to stop rms calculation exactly at last frequency point, so only look at energy from midPointBelow to last frequency point 
  midPointAbove = frequencyArray[frequencyArray.length - 1];
  rmsNoiseSinglePoint = spectralNoiseArray[spectralNoiseArray.length - 1] * Math.sqrt(midPointAbove - midPointBelow);
  rmsNoise = Math.sqrt(rmsNoise * rmsNoise + rmsNoiseSinglePoint * rmsNoiseSinglePoint);
  return rmsNoise;
}

//This utility function take a spectral density and the square root of a frequency span, calculates the rms noise for that span,
//and then adds it to an existing rms sum
function addSpectralToRMSSum(frequencySpanRoot, oldTotalNoise, spectralDensity) {
  var noiseInterval = spectralDensity * frequencySpanRoot;
  var newTotalNoise = Math.sqrt(noiseInterval * noiseInterval + oldTotalNoise * oldTotalNoise);
  return newTotalNoise;
}
function calculateSpectralDensityForOneFrequency(frequency, stage1, stage2) {
  var noiseGain;
  var spectralNoise;
  var stage1noise, stage2noise;
  var complexAlpha = this.calculateComplexAlpha_TIA(frequency, stage1);
  var complexBeta = this.calculateComplexBeta_TIA(frequency, stage1);
  var complexA = this.calculateComplexA(frequency, stage1);

  /************ Stage 1 calculations  ****/
  //calculate op amp voltage noise

  if (stage1.opAmp.feedbackMethod === 'Current') {
    complexAlpha = this.calculateAlphaForCFBVoltageNoise(stage1, frequency);
    noiseGain = this.calculateOpAmpVoltageNoiseGain(complexA, complexBeta, complexAlpha);
  } else {
    noiseGain = this.calculateOpAmpVoltageNoiseGain(complexA, complexBeta);
  }
  spectralNoise = stage1.opAmp.vNoise;
  var opAmpVnoise = noiseGain * spectralNoise;
  var opAmpVGain = noiseGain;

  //calculate op amp current noise
  noiseGain = this.calculateOpAmpCurrentNoiseGain_TIA(complexA, complexBeta, complexAlpha);
  spectralNoise = stage1.opAmp.iNoise;
  var opAmpInoise = noiseGain * spectralNoise;
  var opAmpIGain = noiseGain;

  //calculate rf noise
  noiseGain = this.calculateRfNoiseGain_TIA(complexA, complexBeta, complexAlpha, stage1);
  spectralNoise = Math.sqrt(stage1.rf / 1000) * 4.058e-9;
  var rfNoise = noiseGain * spectralNoise;
  var rfGain = noiseGain;

  //calculate rin noise
  noiseGain = this.calculateRinNoiseGain(complexA, complexBeta, complexAlpha, stage1);
  spectralNoise = Math.sqrt(stage1.rin / 1000) * 4.058e-9;
  var rinNoise = noiseGain * spectralNoise;
  var rinGain = noiseGain;

  //sum everything together
  var totalSpectralDensity = Math.sqrt(opAmpVnoise * opAmpVnoise + opAmpInoise * opAmpInoise + rfNoise * rfNoise + rinNoise * rinNoise);
  stage1noise = {
    total: totalSpectralDensity,
    rf: rfNoise,
    rin: rinNoise,
    opAmpI: opAmpInoise,
    opAmpV: opAmpVnoise,
    complexAlpha: complexAlpha,
    complexBeta: complexBeta,
    complexA: complexA,
    opAmpVGain: opAmpVGain,
    opAmpIGain: opAmpIGain,
    rfGain: rfGain,
    rinGain: rinGain
  };

  /************* Stage 2 calculations *********/
  if (stage2 !== null && stage2 !== undefined) {
    complexAlpha = this.calculateComplexAlpha_Stage2(frequency, stage2);
    complexBeta = this.calculateComplexBeta_Stage2(frequency, stage2);
    complexA = this.calculateComplexA(frequency, stage2);

    //calculate op amp voltage noise
    noiseGain = this.calculateOpAmpVoltageNoiseGain(complexA, complexBeta);
    spectralNoise = stage2.opAmp.vNoise;
    opAmpVnoise = noiseGain * spectralNoise;

    //calculate op amp current noise
    noiseGain = this.calculateOpAmpCurrentNoiseGain_Stage2(complexA, complexBeta, complexAlpha, stage2);
    spectralNoise = stage2.opAmp.iNoise;
    opAmpInoise = noiseGain * spectralNoise;

    //calculate rf noise
    noiseGain = this.calculateRfNoiseGain_Stage2(complexA, complexBeta, complexAlpha, stage2);
    spectralNoise = Math.sqrt(stage2.rf / 1000) * 4.058e-9;
    rfNoise = noiseGain * spectralNoise;

    //calculate rg noise
    noiseGain = this.calculateRgNoiseGain_Stage2(complexA, complexBeta, complexAlpha, stage2);
    spectralNoise = Math.sqrt(stage2.rg / 1000) * 4.058e-9;
    var rgNoise = noiseGain * spectralNoise;

    //calculate rfilter noise
    if (stage2.rfilter !== null && stage2.rfilter !== undefined) {
      noiseGain = this.calculateRfilterNoiseGain(complexA, complexBeta, complexAlpha, stage2);
      spectralNoise = Math.sqrt(stage2.rfilter / 1000) * 4.058e-9;
    } else {
      spectralNoise = 0;
      noiseGain = 0;
    }
    var rfilterNoise = noiseGain * spectralNoise;

    //sum everything together
    totalSpectralDensity = Math.sqrt(opAmpVnoise * opAmpVnoise + opAmpInoise * opAmpInoise + rfNoise * rfNoise + rgNoise * rgNoise + rfilterNoise * rfilterNoise);
    var stage2gain = this.calculateClosedLoopGain(complexA, complexBeta, complexAlpha);
    stage2noise = {
      total: totalSpectralDensity,
      rf: rfNoise,
      rg: rgNoise,
      rfilter: rfilterNoise,
      opAmpI: opAmpInoise,
      opAmpV: opAmpVnoise,
      complexAlpha: complexAlpha,
      complexBeta: complexBeta,
      complexA: complexA,
      gain: stage2gain
    };

    //now refer all stage 1 values to output
    stage1noise.total *= stage2gain;
    stage1noise.rf *= stage2gain;
    stage1noise.rin *= stage2gain;
    stage1noise.opAmpI *= stage2gain;
    stage1noise.opAmpV *= stage2gain;
  } else {
    stage2noise = {
      total: 0,
      rf: 0,
      rg: 0,
      rfilter: 0,
      opAmpI: 0,
      opAmpV: 0
    };
  }
  var totalNoise = Math.sqrt(stage1noise.total * stage1noise.total + stage2noise.total * stage2noise.total);
  return {
    total: totalNoise,
    stage1: stage1noise,
    stage2: stage2noise
  };
}

//Calculates the gain for the photodiode current (i.e the transfer function)
//This is A*alpha/(1+A*beta)
//Returns complex value
function calculateComplexClosedLoopGain(complexA, complexBeta, complexAlpha) {
  'use strict';

  //get A/(1+A*beta)
  var complexTemporary = complexA.mult(complexBeta);
  complexTemporary.real++;
  complexTemporary = complexA.divideDestroy(complexTemporary);

  // now make it alpha*A/(1+A*beta)
  var complexClosedLoopGain = complexAlpha.multDestroy(complexTemporary);
  return complexClosedLoopGain;
}

//Calculates the gain for the photodiode current (i.e the transfer function)
//This is A*alpha/(1+A*beta)
//Returns magnitude
function calculateClosedLoopGain(complexA, complexBeta, complexAlpha) {
  let complexMagnitude = this.calculateComplexClosedLoopGain(complexA, complexBeta, complexAlpha);
  return complexMagnitude.magnitude();
}

//This function performs:  A/(1+A*beta) or alpha * A / (1+A*beta) in the CFB case where complexAlpha is defined
function calculateOpAmpVoltageNoiseGain(complexA, complexBeta, complexAlpha) {
  'use strict';

  var complexTemporary = complexA.mult(complexBeta);
  complexTemporary.real++;
  complexTemporary = complexA.divideDestroy(complexTemporary);
  if (complexAlpha !== undefined) {
    complexTemporary = complexAlpha.multDestroy(complexTemporary);
  }
  var noiseGain = complexTemporary.magnitude();
  return noiseGain;
}

//Current noise gain is exactly the same as the closed loop gain, so just call that and return magnitude
function calculateOpAmpCurrentNoiseGain_TIA(complexA, complexBeta, complexAlpha) {
  return this.calculateClosedLoopGain(complexA, complexBeta, complexAlpha);
}

//Current noise gain easy if it's inverting configuration, more complicated with noninverting
function calculateOpAmpCurrentNoiseGain_Stage2(complexA, complexBeta, complexAlpha, stage) {
  'use strict';

  var iGain;

  //Alpha for noninverting section needs to include both rf || rg impedance as well as cfilter || rfilter impedance
  if (stage.rfilter !== undefined) {
    //first calculate current noise for inverting input:
    var complexRfRg = _complex.default.createComplex(stage.rf * stage.rg / (stage.rf + stage.rg), 0);
    var invertingIgain = this.calculateClosedLoopGain(complexA, complexBeta, complexRfRg);
    //now noninverting input:
    var complexRfilter = _complex.default.createComplex(stage.rfilter, 0);
    var complexFilterImpedance = complexAlpha.multDestroy(complexRfilter);
    var noninvertingIgain = this.calculateClosedLoopGain(complexA, complexBeta, complexFilterImpedance);
    //add together
    iGain = Math.sqrt(invertingIgain * invertingIgain + noninvertingIgain * noninvertingIgain);
  } else {
    //inverting configuration.   Multiple original alpha by rf to convert voltage divider to parallel
    var complexRf = _complex.default.createComplex(stage.rf, 0);
    var iGainAlpha = complexAlpha.multDestroy(complexRf);
    iGain = this.calculateClosedLoopGain(complexA, complexBeta, iGainAlpha);
  }
  return iGain;
}

//This function performs:  rfAlpha*A/(1+A*beta)
//rfAlpha has the same pole as the circuit's alpha, but has a gain of Rin/(Rin+Rf) rather than Rf||Rin
//Therefore we divide the circuit alpha by Rf to get the rfAlpha
function calculateRfNoiseGain_TIA(complexA, complexBeta, complexAlpha, stage) {
  var complexRf = _complex.default.createComplex(stage.rf, 0);
  var complexRfAlpha = complexAlpha.divideDestroy(complexRf);

  //now that we have a new complexAlpha, we can use the same math as the calculateClosedLoopGain function
  return this.calculateClosedLoopGain(complexA, complexBeta, complexRfAlpha);
}
function calculateRfNoiseGain_Stage2(complexA, complexBeta, complexAlpha, stage) {
  'use strict';

  var complexRfAlpha;

  //noninverting
  if (stage.rfilter !== undefined) {
    complexRfAlpha = complexBeta;
  }
  //inverting
  else {
    var rfOverRg = stage.rf / stage.rg;
    complexRfAlpha = _complex.default.createComplex(rfOverRg * complexAlpha.real, rfOverRg * complexAlpha.imaginary);
  }

  //now that we have a new complexAlpha, we can use the same math as the calculateClosedLoopGain function
  return this.calculateClosedLoopGain(complexA, complexBeta, complexRfAlpha);
}
function calculateRgNoiseGain_Stage2(complexA, complexBeta, complexAlpha, stage) {
  'use strict';

  var complexRgAlpha;

  //noninverting
  if (stage.rfilter !== undefined) {
    var rfOverRg = stage.rf / stage.rg;
    complexRgAlpha = _complex.default.createComplex(rfOverRg * complexBeta.real, rfOverRg * complexBeta.imaginary);
  }
  //inverting
  else {
    complexRgAlpha = complexAlpha;
  }

  //now that we have a new complexAlpha, we can use the same math as the calculateClosedLoopGain function
  return this.calculateClosedLoopGain(complexA, complexBeta, complexRgAlpha);
}

//rfilter noise gain is same as the transfer function of 2nd stage
function calculateRfilterNoiseGain(complexA, complexBeta, complexAlpha, stage) {
  //noninverting
  if (stage.rfilter !== undefined) return this.calculateClosedLoopGain(complexA, complexBeta, complexAlpha);
  //inverting, this resistor doesn't exist
  else return 0;
}

//This function performs:  rinAlpha*A/(1+A*beta)
//rinAlpha has the same pole as the circuit's alpha, but has a gain of Rf/(Rin+Rf) rather than Rf||Rin
//Therefore we divide the circuit alpha by Rin to get the rfAlpha
function calculateRinNoiseGain(complexA, complexBeta, complexAlpha, stage) {
  'use strict';

  var complexRin = _complex.default.createComplex(stage.rin, 0);
  var complexRinAlpha = complexAlpha.divideDestroy(complexRin);
  var complexDenom = complexAlpha.mult(complexBeta);
  complexDenom.real++;
  var complexRinNoiseGain = complexA.multDestroy(complexRinAlpha).divideDestroy(complexDenom);
  return complexRinNoiseGain.magnitude();
}
function getActualFpFq(loopFp, loopQ, stagesObject, inputValues) {
  var actualFp, actualQ;

  //Compute frequency range - we don't need near the amount of points we use for graphing to get a pretty good approximation, so no sense using the typical frequency range, since it will make things slower.
  // We'll just use 50 points.
  var startFreq = loopFp / 5;
  var stopFreq = loopFp * 2;
  var pointsPerDecade = 50;
  var newFreqPoints = Common.frequencyPoint(startFreq, stopFreq, pointsPerDecade); //call to frequency point function

  //create simplex array
  var fpArray = [loopFp, loopFp * 0.99, loopFp * 0.99, loopFp, loopFp * 0.96];
  var qArray = [loopQ, loopQ * 1.005, loopQ, loopQ * 1.01, loopQ * 1.1];
  var pointsInfpArray = fpArray.length;
  var errorArray = [];

  //create error simplex by comparing ideal frequency response generated with fp and Q vs. actual magnitude response
  let magnitudeArray = this.createMagnitudeArray(newFreqPoints, stagesObject, inputValues, false);
  for (var j = 0; j < pointsInfpArray; j++) {
    errorArray[j] = Common.calculateNelderMeadError(newFreqPoints, fpArray[j], qArray[j], magnitudeArray);
  }

  //Implementation of NELDER MEAD STATE MACHINE
  var centerOfGravityFp = 0,
    centerOfGravityQ = 0,
    state = 'centerOfGravity',
    reflectedFp,
    reflectedQ,
    reflectedError,
    expandedFp,
    expandedQ,
    expandedError,
    contractedFp,
    contractedQ,
    contractedError,
    fpQErrorObj = [],
    fpQErr = [],
    errorPercentCheck = false,
    fpArraylen = fpArray.length,
    qArraylen = qArray.length,
    errLen = errorArray.length,
    count = 0;
  for (var k = 0; k < errLen; k++) {
    fpQErrorObj.push({
      fp: fpArray[k],
      q: Number(qArray[k]),
      error: Number(errorArray[k])
    });
  }
  fpQErr = Common.sortErrorArray(fpQErrorObj);
  do {
    if (state == 'centerOfGravity') {
      //finding the average of fpArray, except for last point
      var sumFp = 0;
      var avgFp;
      for (let i = 0; i < fpArraylen - 1; i++) {
        sumFp += fpQErr[i].fp;
      }
      avgFp = sumFp / (fpArraylen - 1);
      centerOfGravityFp = avgFp;
      var sumQ = 0;
      var avgQ;
      for (let i = 0; i < qArraylen - 1; i++) {
        sumQ += Number(fpQErr[i].q);
      }
      avgQ = sumQ / (qArraylen - 1);
      centerOfGravityQ = avgQ;
      reflectedFp = 2 * centerOfGravityFp - fpQErr[fpArraylen - 1].fp;
      reflectedQ = 2 * centerOfGravityQ - Number(fpQErr[qArraylen - 1].q);
      reflectedError = Common.calculateNelderMeadError(newFreqPoints, reflectedFp, reflectedQ, magnitudeArray);

      //checking if reflectedError is smaller than any points in ErrorArray
      errLen = fpQErr.length;
      if (reflectedError < fpQErr[0].error) {
        state = 'expansion';
      } else if (reflectedError >= fpQErr[errLen - 2].error) {
        state = 'contraction';
      } else {
        fpQErr[fpArraylen - 1].fp = reflectedFp;
        fpQErr[qArraylen - 1].q = reflectedQ;
        fpQErr[errLen - 1].error = reflectedError;
        state = 'centerOfGravity';
      }
    }
    if (state == 'expansion') {
      expandedFp = 3 * centerOfGravityFp - 2 * fpQErr[fpArraylen - 1].fp;
      expandedQ = 3 * centerOfGravityQ - 2 * Number(fpQErr[qArraylen - 1].q);
      expandedError = Common.calculateNelderMeadError(newFreqPoints, expandedFp, expandedQ, magnitudeArray);
      if (expandedError < reflectedError) {
        fpQErr[fpArraylen - 1].fp = expandedFp;
        fpQErr[qArraylen - 1].q = expandedQ;
        fpQErr[errLen - 1].error = expandedError;
      } else {
        fpQErr[fpArraylen - 1].fp = reflectedFp;
        fpQErr[qArraylen - 1].q = reflectedQ;
        fpQErr[errLen - 1].error = reflectedError;
      }
    }
    if (state == 'contraction') {
      contractedFp = 0.5 * centerOfGravityFp + 0.5 * fpQErr[fpArraylen - 1].fp;
      contractedQ = 0.5 * centerOfGravityQ + 0.5 * Number(fpQErr[qArraylen - 1].q);
      contractedError = Common.calculateNelderMeadError(newFreqPoints, contractedFp, contractedQ, magnitudeArray);
      if (contractedError < fpQErr[errLen - 1].error) {
        fpQErr[fpArraylen - 1].fp = contractedFp;
        fpQErr[qArraylen - 1].q = contractedQ;
        fpQErr[errLen - 1].error = contractedError;
      } else {
        for (let j = 1; j < fpArraylen; j++) {
          fpQErr[j].fp = fpQErr[0].fp + 0.5 * (fpQErr[j].fp - fpQErr[0].fp);
          fpQErr[j].q = Number(fpQErr[0].q) + 0.5 * (Number(fpQErr[j].q) - Number(fpQErr[0].q));
          fpQErr[j].error = Common.calculateNelderMeadError(newFreqPoints, fpQErr[j].fp, fpQErr[j].q, magnitudeArray);
        }
      }
    }

    // sort the error array
    var fpQErr1 = Common.sortErrorArray(fpQErr);
    fpQErr = fpQErr1;

    // check the error percent
    errorPercentCheck = Common.checkErrorPercent(fpQErr);
    count++;
    if (count == 1000 || fpQErr[0].error < 1e-6) {
      //if ((count == 1000)) {
      break;
    } else {
      state = 'centerOfGravity';
    }
  } while (errorPercentCheck == false); // check if all errors in error array lies between 1% of each other and number of iterations >1000
  actualFp = fpQErr[0].fp; // first point in fp array
  actualQ = fpQErr[0].q; // first point in q array

  return [actualFp, actualQ];
}